import { LoginOption } from "@modules/user/shared/constants"

export type LoginButtonOption = Exclude<
  LoginOption,
  LoginOption.GithubEnterprise | LoginOption.GitlabSelfManaged
>

export function useAvailableLoginOptions() {
  const availableLoginOptions: LoginButtonOption[] = [
    LoginOption.Github,
    LoginOption.Gitlab,
    LoginOption.Bitbucket,
    LoginOption.Google,
  ]

  return availableLoginOptions
}
